<template>
<div>
  <el-dialog
      title="Confirm Delete"
      :visible.sync="should_show_confirm_delete">

    <p>Are you sure you want to delete?</p>
    <el-button v-on:click="deleteStepTwo()" type="danger">Yes, really delete.</el-button>
    <el-button v-on:click="cancelDelete()" type="success">Oops. Actually, do not delete.</el-button>

  </el-dialog>
  <el-dialog
             title="Edit Target"
             :visible.sync="should_show_dialog"
  >
    <FormManager
        prettyEndPoint="/api/targets/pretty"
        :initialFormValues="initialValues"
        :events="events"
        @save="save"
    />
  </el-dialog>
  <el-button @click="showDialog(null)" style="float:right;margin-bottom:10px;">Add Target</el-button>

  <h1>Targets</h1>

  <el-table border :data="targets" style="width: 100%;margin-bottom: 20px;">
      <el-table-column
          prop="name"
          label="Name"
      >
      </el-table-column>
      <el-table-column
          prop="nice_agg"
          label="Aggregation"
      >
      </el-table-column>
      <el-table-column
          prop="comparator"
          label="Comparator"
      >
      </el-table-column>
      <el-table-column
          prop="bad_threshold"
          label="Bad Threshold"
      >
      </el-table-column>
      <el-table-column
          prop="good_threshold"
          label="Good Threshold"
      >
      </el-table-column>
      <el-table-column
          prop="nice_direction"
          label="Target Direction"
      >
      </el-table-column>
      <el-table-column
          prop="display_precision"
          label="Decimal Places"
      >
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button @click="showDialog(scope.row)" type="text" size="small">Edit</el-button>
          <el-button @click="deleteStepOne(scope.row.id)" type="text" size="small">Delete</el-button>
        </template>
      </el-table-column>
  </el-table>

</div>
</template>

<script>
export default {
  name: "TargetList",
  props: ['extent_id_from_blade'],
  data() {
    return {
      targets: [],
      events: {
        save: {
          label: "Save" ,
          event: "save"
        },
      },
      emptyTarget: {
        name: '',
        aggregation: 1,
        comparator: null,
        bad_threshold: 0,
        good_threshold: 0,
        direction: 1,
        decimal_places: 0,
      },
      should_show_dialog: false,
      initialValues: null,
      tentative_delete_id: null,
      should_show_confirm_delete: false,
    }
  },
  mounted() {
    this.getTargets()
  },
  methods: {
    getTargets() {
      axios.get('/api/targets/' + this.extent_id_from_blade)
          .then(response => {
            this.targets = response.data
          })
          .catch(error => {
            console.log('oops getting targets')
          })
    },
    showDialog(item) {
      if (item && item.id) {
        this.initialValues = item
      } else {
        this.initialValues = this.emptyTarget
      }
      this.should_show_dialog = true
    },
    deleteStepOne(id) {
      this.tentative_delete_id = id
      this.should_show_confirm_delete = true
    },
    cancelDelete() {
      this.should_show_confirm_delete = false
      console.log('canceling delete')
    },
    deleteStepTwo() {
      axios.delete('/api/targets/' + this.tentative_delete_id)
          .then(response => {
            console.log('deleted')
            this.getTargets()
            this.should_show_confirm_delete = false
          })
          .catch(error => {
            console.log('could not delete')
          })
    },
    save(values) {
      axios.post('/api/targets/' + this.extent_id_from_blade, {
        target: values
      })
          .then(response => {
            this.getTargets()
            this.should_show_dialog = false
          })
          .catch(error => {
            console.log('could not save')
          })
    },
  },
}
</script>

<style scoped>

</style>